module.exports = __webpack_public_path__ + "static/img/container1.5e9fc52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainpage/container1.png
// module id = DQ6x
// module chunks = 18